module.exports = __webpack_public_path__ + "static/media/back.f62e79a0.svg";